/**
 * @typedef PropsSwatch
 * @property { string } url
 * @property { boolean } isActive
 * @property { string } title
 * @property { { src: string, alt: string } } [image]
 * @property { string } [hex]
 * @property { string } [text]
 * @property { boolean } [isAvailable]
 */

/**
 * Image will supercede hex which will supercede text
 * @param { PropsSwatch } param0
 * @returns { React.FC }
 */
export const Swatch = ({ url = '', isActive = false, title = '', image, hex, text = '', isAvailable = true }) => {
  if (!image.src && !hex && !text) {
    console.error('Must specify an image, hex, or text for a swatch')
    return <></>
  }

  const isActiveStyling = isActive ? 'product-linked-item-selected border-grey-900 border-accent-1 p-0.5' : ''
  const isAvailableStyling = isAvailable ? '' : 'cursor-not-allowed'

  const swatchInner =
    image.src || hex ? (
      <span
        className={`product-linked-item-color block h-full w-full rounded-full border ${isActiveStyling} ${isAvailableStyling}`}
        style={`${image.src ? `background: url(${image.src})` : `background-color: ${hex}`} `}
      ></span>
    ) : (
      <span className="flex h-full w-full select-none items-center justify-center rounded-full border">{text}</span>
    )

  return url ? (
    <a href={url} className={`product-linked-item block h-10 w-10 rounded-full border ${isActiveStyling} ${isAvailableStyling}`} title={title}>
      {swatchInner}
    </a>
  ) : (
    <div className={`product-linked-item block h-10 w-10 rounded-full border ${isActiveStyling} ${isAvailableStyling}`} title={title}>
      {swatchInner}
    </div>
  )
}
